import React, {useState} from 'react';
import {
    CardBody, Col,
    FormGroup,
    Input, Label,
    Row,
} from 'reactstrap';
import {YES_CONTINUE} from "../../../components/i18n/i18n";
import {FL_CODE, FL_INTEREST, FL_PLACE, FL_STATUS, FL_TYPE} from "../../../components/i18n/formLabels";
import SelectGeneric from "../../../components/select/selectGeneric";
import {typeNodeProvider} from "./nodeTypeProvider";
import Switch from "react-bootstrap-switch";
import {placeProvider} from "../../../providers/placeProvider";

export default function PointInpunt(props) {
    const udn = localStorage.getItem('selectedUdn') !== '' ? JSON.parse(localStorage.getItem('selectedUdn')) : null
    const [code, setCode] = useState(props.selectedNode?.title !== undefined ? props.selectedNode?.title : '');
    const [type, setType] = useState(props.selectedNode?.type !== undefined ? props.selectedNode?.type : 'room');
    const [status, setStatus] = useState(props.selectedNode?.status || false);
    const [interest, setInterest] = useState(props.selectedNode?.interest || false);
    const [placeId, setPlaceId] = useState(props.selectedNode?.place?.id || null);

    const onClick = () => {
        if (props.selectedNode?.title === undefined) {
            props.addNode( code, type, status, interest, { id : placeId } )
            props.onClose()
        } else {
            let _node = props.selectedNode
            _node.title = code
            _node.type = type
            _node.status = status
            _node.interest = interest
            _node.place = { id : placeId }
            props.onEditNode( _node )
            props.onClose()
        }
    }

    return (
        <div className='custom-ui-form'>
            <CardBody className="">
                <h1>{'Información del punto'}</h1>
                <Row>
                    <Col md="6">
                        <FormGroup>
                            <Label>{ FL_CODE }</Label>
                            <Input
                                type="text"
                                name="code"
                                autoFocus={true}
                                value={code}
                                placeholder={''}
                                onChange={e => setCode(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label>{ FL_TYPE }</Label>
                            <SelectGeneric
                                initialValue={ type }
                                setExternalValue={ value => setType( value ) }
                                isDisabled={ false }
                                provider = { typeNodeProvider }
                            />
                        </FormGroup>
                    </Col>

                    <Col  md="3">
                        <FormGroup>
                            <Label>{FL_STATUS}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={status}
                                disabled={false}
                                onChange={() => setStatus(!status)}
                            />
                        </FormGroup>
                    </Col>
                    <Col  md="3">
                        <FormGroup>
                            <Label>{FL_INTEREST}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={interest}
                                disabled={ false }
                                onChange={() => setInterest(!interest)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label>{FL_PLACE}</Label>
                            <SelectGeneric
                                initialValue = { placeId }
                                setExternalValue = { value => setPlaceId( value ) }
                                isDisabled = { false }
                                provider = { placeProvider }
                                customFilter={{item: {udn: {id: udn.id}}} }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <button className="btn-alert-delete" onClick={onClick} >
                    { YES_CONTINUE }
                </button>
            </CardBody>
        </div>
    )
}